import LinkOrdemCompra from "@/modules/LinkOrdemCompra/Index.vue";

export default [
  {
    path: "/ordemcompra/:uuid",
    component: LinkOrdemCompra,
    meta: { title: "Ordem Digital" },
  },
];
